import { WBTypography } from "@apptractive/design-system-web";
import { useTranslation } from "react-i18next";

const NotFound = () => {
  const { t } = useTranslation();

  return (
    <>
      <WBTypography>{t("404NotFound", { ns: "common" })}</WBTypography>
    </>
  );
};

export default NotFound;
